export default {
  inserted(el) {
    const wrapper = document.createElement('div')
    wrapper.classList.add('sticky-table-bar-wrapper')

    el._stickyWrapper = wrapper

    const onScroll = () => {
      const shouldStick = window.scrollY > 100

      if (shouldStick && !wrapper.contains(el)) {
        const height = el.offsetHeight + 'px'
        wrapper.style.minHeight = height

        wrapper.classList.add('sticky-table-bar')
        el.parentNode.insertBefore(wrapper, el)
        wrapper.appendChild(el)
      }

      if (!shouldStick && wrapper.parentNode) {
        wrapper.parentNode.insertBefore(el, wrapper)
        wrapper.remove()
        wrapper.style.minHeight = ''
      }
    }

    window.addEventListener('scroll', onScroll)
    el._onScroll = onScroll
  },

  unbind(el) {
    window.removeEventListener('scroll', el._onScroll)
    delete el._onScroll
    delete el._stickyWrapper
  }
}
